import { InlineConfirmContainer, IInlineElement } from './inline-confirm-container';
import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class InlineElement implements IInlineElement {
	@bindable onlyThisVisible: boolean;
	visible = true;

	constructor(private container: InlineConfirmContainer) {
		container.addElement(this);
	}

	hide() {
		this.visible = false;
	}

	show() {
		this.visible = true;
	}

	onlyThisVisibleChanged(newValue: boolean) {
		if (newValue) {
			this.container.hideElementsExcept(this);
		} else {
			this.container.showElements();
		}
	}
}
